import React, { useCallback, useEffect, useRef, useState } from "react";
import type { TaskType } from "@myapp/contract";
import { Button } from "../../../../shared/ui/controls/Button/Button";
import { taskTypeOptions } from "../../../../entities/task";
import { useUpsertTask } from "../../../../features/task-upsert";
import { IconButton } from "src/shared/ui/icons/IconButton/IconButton";
import { CalendarClock } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { routes } from "src/shared/config/routes";

export const TaskButtons: React.FC = () => {
  const navigate = useNavigate()
  const { openCreate } = useUpsertTask();
  return (
    <>
      <Button
        variant="surface"
        className="w-[260px]"
        onClick={() => openCreate('ERRANDS')}
      >
        Neue Aufgabe
      </Button>
      <IconButton
      className="min-w-[40px]"
        variant="primary"
        icon={<CalendarClock size={16} />}
        label="Planen"
        aria-label="Auf Kalender planen"
        title="Auf Kalender planen"
        onClick={() => navigate(routes.disposition.planTask())}
      />
    </>
  );
};
